export const CAMPAIGNS_DATA = [
  {
    id: 'c1',
    name: 'Meta Brand Awareness Push',
    channel: 'meta',
    agent: 'marsi',
    status: 'live',
    alert: true,
    startDate: 'Jan 22',
    budget: { spent: 2100, total: 5000 },
    metrics: [
      { label: 'Impressions', value: '28.4K' },
      { label: 'CTR', value: '1.9%', alert: true, target: '2.8%' },
      { label: 'Leads', value: '12' },
      { label: 'CPL', value: '$175' },
      { label: 'Conversions', value: '3' },
    ],
    description: 'Broad awareness campaign targeting SMB founders. CTR is below target — Marsi recommends narrowing audience.',
    thinking: 'Marsi analyzed the first 5 days of campaign data. The "broad SMB" segment generates impressions but low engagement. VP+ titles convert at 3.4x the rate of general targeting. Recommends narrowing and pausing underperforming ad set B.',
    recommendations: [
      { label: 'Narrow targeting to VP+ titles', agent: 'marsi', status: 'pending-approval' },
      { label: 'Pause underperforming ad set B', agent: 'marsi', status: 'pending-approval' },
      { label: 'Reallocate $800 to top-performing creative', agent: 'marsi', status: 'pending-approval' },
    ],
    artifacts: [
      { name: 'Campaign Brief', type: 'pdf' },
      { name: 'Performance Report', type: 'spreadsheet' },
      { name: 'Audience Analysis', type: 'pdf' },
    ],
  },
  {
    id: 'c2',
    name: 'LinkedIn Developer Series',
    channel: 'linkedin',
    agent: 'marsi',
    status: 'ready',
    alert: false,
    startDate: 'Pending launch',
    budget: { spent: 0, total: 3200 },
    metrics: [
      { label: 'Target Reach', value: '62K' },
      { label: 'Expected MQLs', value: '40-55' },
      { label: 'Duration', value: '4 weeks' },
      { label: 'Content', value: '8 posts + 2 forms' },
    ],
    description: 'Sponsored content series targeting VP+ at dev tool companies. All creatives reviewed by Wright.',
    thinking: 'Marsi designed this based on the Q1 GTM strategy. Developer-focused use-case content outperforms product features by 2.1x on LinkedIn for our audience. Campaign is ready — awaiting Priya\'s launch approval.',
    recommendations: [
      { label: 'Launch with Variant B creative (data-led)', agent: 'marsi', status: 'recommended' },
      { label: 'Set bid strategy to maximize conversions', agent: 'marsi', status: 'recommended' },
    ],
    artifacts: [
      { name: 'Campaign Brief', type: 'pdf' },
      { name: 'Creative Mockups (3 variants)', type: 'image' },
      { name: 'Targeting Config', type: 'pdf' },
    ],
  },
  {
    id: 'c3',
    name: 'PLG Content Series',
    channel: 'blog',
    agent: 'wright',
    status: 'live',
    alert: false,
    startDate: 'Jan 13',
    budget: { spent: 800, total: 1200 },
    metrics: [
      { label: 'Blog Traffic', value: '+14% WoW' },
      { label: 'Organic Leads', value: '18' },
      { label: 'Avg. Time on Page', value: '4m 12s' },
      { label: 'Keywords Ranking', value: '3 in top 10' },
    ],
    description: 'Product-led growth blog series driving organic traffic. Three target keywords now ranking in top 10.',
    thinking: 'Wright identified 3 high-volume, low-competition keywords. Blog posts optimized for these are generating consistent organic traffic. The series is outperforming paid channels on CPL ($44 vs $175 for Meta).',
    recommendations: [
      { label: 'Double publish cadence from 2 to 4 posts/week', agent: 'wright', status: 'recommended' },
      { label: 'Add internal linking to boost SEO authority', agent: 'wright', status: 'in-progress' },
    ],
    artifacts: [
      { name: 'Content Calendar', type: 'spreadsheet' },
      { name: 'SEO Performance Report', type: 'spreadsheet' },
    ],
  },
  {
    id: 'c4',
    name: 'Email Nurture — Trial Users',
    channel: 'email',
    agent: 'marsi',
    status: 'live',
    alert: false,
    startDate: 'Jan 6',
    budget: { spent: 150, total: 400 },
    metrics: [
      { label: 'Open Rate', value: '34%' },
      { label: 'Click Rate', value: '8.2%' },
      { label: 'Unsubscribes', value: '0.3%' },
      { label: 'Conversions', value: '6' },
    ],
    description: '5-email drip sequence for free trial users. Performing above industry benchmarks.',
    thinking: 'Marsi A/B tested subject lines across the first 3 emails. Personalized subject lines (with company name) outperform generic by 22%. Sequence converting at 6% — healthy for SaaS nurture.',
    recommendations: [
      { label: 'Add email #6 with case study', agent: 'marsi', status: 'recommended' },
    ],
    artifacts: [
      { name: 'Email Sequence', type: 'pdf' },
      { name: 'A/B Test Results', type: 'spreadsheet' },
    ],
  },
  {
    id: 'c5',
    name: 'LinkedIn Thought Leadership',
    channel: 'linkedin',
    agent: 'buzz',
    status: 'live',
    alert: false,
    startDate: 'Jan 15',
    budget: { spent: 0, total: 0 },
    metrics: [
      { label: 'Posts Published', value: '8' },
      { label: 'Impressions', value: '12.3K' },
      { label: 'Engagement Rate', value: '4.8%' },
      { label: 'Followers Gained', value: '+120' },
    ],
    description: 'Organic LinkedIn thought leadership by Buzz. Building brand presence through consistent posting.',
    thinking: 'Buzz analyzed top-performing posts from competitors. Carousel posts get 3.2x more engagement than single-image. Recommendation: shift to 60% carousel, 40% text-based posts.',
    recommendations: [
      { label: 'Increase carousel ratio to 60%', agent: 'buzz', status: 'recommended' },
    ],
    artifacts: [
      { name: 'Post Calendar', type: 'spreadsheet' },
      { name: 'Engagement Report', type: 'pdf' },
    ],
  },
  {
    id: 'c6',
    name: 'Product Launch — v2.4 Announcement',
    channel: 'multi',
    agent: 'marsi',
    status: 'draft',
    alert: false,
    startDate: 'Target: Feb 10',
    budget: { spent: 0, total: 8500 },
    metrics: [
      { label: 'Channels', value: '5 (LinkedIn, Meta, Blog, Email, Twitter)' },
      { label: 'Target Reach', value: '150K+' },
      { label: 'Content Pieces', value: '12' },
      { label: 'Timeline', value: '2 weeks prep' },
    ],
    description: 'Cross-channel product launch campaign. Marsi is coordinating with Wright and Buzz on content.',
    thinking: 'Marsi is building the launch playbook based on v2.3 learnings. Key change: front-loading LinkedIn + blog content 3 days before the announcement to build anticipation. Wright is drafting the blog post and Buzz is preparing social assets.',
    recommendations: [
      { label: 'Finalize launch blog post by Feb 3', agent: 'wright', status: 'in-progress' },
      { label: 'Prepare social countdown assets', agent: 'buzz', status: 'in-progress' },
      { label: 'Set up email blast for existing users', agent: 'marsi', status: 'exploring' },
    ],
    artifacts: [
      { name: 'Launch Playbook', type: 'pdf' },
      { name: 'Timeline', type: 'spreadsheet' },
    ],
  },
  {
    id: 'c7',
    name: 'Q4 Retargeting — Churned Leads',
    channel: 'meta',
    agent: 'marsi',
    status: 'paused',
    alert: false,
    startDate: 'Dec 15 (paused Jan 20)',
    budget: { spent: 1800, total: 3000 },
    metrics: [
      { label: 'Impressions', value: '45K' },
      { label: 'CTR', value: '2.1%' },
      { label: 'Leads Re-engaged', value: '8' },
      { label: 'CPL', value: '$225' },
    ],
    description: 'Retargeting campaign for Q4 churned leads. Paused due to high CPL — awaiting budget review.',
    thinking: 'CPL of $225 is 2x target. Marsi recommends either revising the creative (current copy is too generic) or redirecting budget to LinkedIn retargeting which historically performs better for re-engagement.',
    recommendations: [
      { label: 'Revise creative with personalized messaging', agent: 'marsi', status: 'recommended' },
      { label: 'Consider moving budget to LinkedIn retargeting', agent: 'marsi', status: 'recommended' },
    ],
    artifacts: [
      { name: 'Performance Report', type: 'spreadsheet' },
    ],
  },
];

export const CAMPAIGN_FILTERS = {
  statuses: ['all', 'live', 'ready', 'draft', 'paused'],
  channels: ['all', 'linkedin', 'meta', 'blog', 'email', 'multi'],
  agents: ['all', 'marsi', 'wright', 'buzz'],
};

export const CAMPAIGN_CHAT_RESPONSES = {
  general: {
    text: "Here's your campaign overview.\n\nYou have 4 live campaigns, 1 ready for launch, 1 in draft, and 1 paused. The Meta Brand Awareness campaign needs immediate attention — CTR is underperforming and I've prepared 3 recommendations.\n\nThe LinkedIn Developer Series is fully prepped and waiting for your go-ahead. Want me to walk through the launch checklist?",
  },
  create: {
    text: "Let's set up a new campaign. I'll need a few things to get started:\n\n1. **Goal** — Awareness, lead gen, or re-engagement?\n2. **Channel** — LinkedIn, Meta, Email, Blog, or multi-channel?\n3. **Budget** — Approximate range?\n4. **Timeline** — When do you want to launch?\n\nOnce I have these, I'll draft the campaign brief, build targeting recommendations, and coordinate with Wright for creative if needed.",
  },
};
